
(function () {
    "use strict";

    angular
        .module("atheer.session")
        .controller(
            "DeleteLinkedJobDialogController",
            DeleteLinkedJobDialogController
        );

    function DeleteLinkedJobDialogController($scope, $mdDialog) {
        $scope.deleteSessionLinkedJob = function () {
            $mdDialog.hide();
        };
        $scope.cancelSessionJobLinkModal = function () {
            $mdDialog.cancel();
        };
    }
})();
